import { Intent } from '@blueprintjs/core'
import { createElement as h, ReactNode } from 'react'
import { FieldRenderProps } from 'react-final-form'
import { TranslationFunction } from 'react-i18next'

import { i18nKeys } from '../../app/app.i18n'
import { isPresent } from '../../app/shared'

type FieldRenderMeta = FieldRenderProps['meta']

export const identity = <T>(_: T) => _
export const isString = (_: any): _ is string => typeof _ === 'string'

export const createRequiredLabel = (value: string | ReactNode, translate: TranslationFunction) =>
  isString(value) ? h('span', { className: 'label-required' }, `${translate(value)}`) : value

export const createHelperText = (meta: FieldRenderMeta, text: ReactNode | string, translate: TranslationFunction) => {
  const { error, submitError, touched } = meta
  const hasErrorVisible = (error && touched) || submitError

  return hasErrorVisible ? h('span', {}, text, translate(submitError || error.split(' ')[0])) : text
}

export const getIntent = (meta: FieldRenderMeta, intent: Intent = Intent.NONE) => {
  const { error, submitError, touched } = meta
  const hasErrorVisible = (error && touched) || submitError

  return hasErrorVisible ? Intent.DANGER : intent
}

export const createLabelWithId = (input: { name: string }, label?: ReactNode) => {
  return {
    id: input.name,
    labelText: label || input.name,
  }
}

export const createFileNameValue = (input: { value: File }): string => {
  const { name } = input.value

  return isPresent(name) ? name : i18nKeys.core.common.chooseFile
}



// WEBPACK FOOTER //
// ./src/modules/forms/utils.ts